import React from "react";

import ReusableEdit from "../ReusableEdit";

function Edit() {
  return <ReusableEdit></ReusableEdit>;
}

export default Edit;
